"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function keys(o) {
    return Object.keys(o);
}
exports.keys = keys;
var salt = Math.floor(Date.now() * Math.random());
var counter = 0;
function uniqueId(prefix) {
    return prefix + "-" + salt + "-" + counter++;
}
exports.uniqueId = uniqueId;
function toArray(some) {
    return Array.isArray(some) ? some : [some];
}
exports.toArray = toArray;
function pipe() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (data) { return args.reduce(function (acc, cb) { return cb(acc); }, data); };
}
exports.pipe = pipe;
